let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5g5GD"), load("5HsIb"), load("6KDUv")]).then(() => parcelRequire('iiqL3'));